<template>
  <FormKit
    v-bind="$attrs"
    v-model="_value"
  />
</template>

<script>
export default {
  name: 'FormInputSimple',
  inheritAttrs: false,
  props: {
    /**
     * Value bound via v-model.
     */
    modelValue: {
      type: [String, Number, Boolean, Object, Array],
      default: ''
    },
  },
  emits: ['update:modelValue'],
  computed: {
    _value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
</style>
